import React from "react";
import userService from "../../services/user.service";
import ReactPlayer from "react-player";
import moment from "moment";
import shareIcon from "../../assets/images/public/share-icon.png";
import { ShareModal } from "./shareModal";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import blankProfile from "../../assets/images/blank-profile.png";
import backIcon from "../../assets/images/public/back-icon.png";
import { Link } from "react-router-dom";
class ContactUs extends React.Component {
  constructor() {
    super();
    this.state = {
      shareMediaDetailsResponses: [],
      visible: false,
      socialShare: "",
      inputUrl: "",
      flag: null,
      loading: false,
      searchedRecord: false,
      searchQuery: "",
    };
  }

  componentDidMount() {
    this.getHighlightedVideo();
  }

  getHighlightedVideo() {
    const { searchedRecord } = this.state;
    // this.setState({ loading: true });
    if (searchedRecord) {
      this.setState({ searchedRecord: false });
    }
    userService.getHighlightsForSchool().then((res) => {
      var shareMediaDetailsResponses = res.data.data.shareMediaDetailsResponses;
      this.setState({ shareMediaDetailsResponses });
      if (shareMediaDetailsResponses.length == 0) {
        this.setState({ flag: true });
      }
    });
  }

  postSearchHighlight(searchTring) {
    if (searchTring.length > 1) {
      userService.searchHighlightsVideo(searchTring).then((res) => {
        var shareMediaDetailsResponses =
          res.data.data.shareMediaDetailsResponses;
        this.setState({ shareMediaDetailsResponses, searchedRecord: true });
      });
    } else {
      this.getHighlightedVideo();
    }
  }

  setDialogData = (url, visible) => {
    this.setState({
      visible: visible,
      socialShare: url,
      inputUrl: url,
    });
  };

  handleChange = (url) => {
    this.setState({
      inputUrl: url,
    });
  };

  increaseViewCount = (id) => {
    let viewsId = JSON.parse(localStorage.getItem("highlight")) || [];
    if (!viewsId.includes(id)) {
      viewsId.push(id);
      localStorage.setItem("highlight", JSON.stringify(viewsId));
      userService.viewCountPost(true, id).then(() => {
        this.getHighlightedVideo();
      });
    }
  };

  render() {
    const {
      shareMediaDetailsResponses,
      visible,
      socialShare,
      inputUrl,
      flag,
      loading,
      searchQuery,
      searchedRecord,
    } = this.state;
    return (
      <>
        <section className="highlight-section">
          <div
            className={
              shareMediaDetailsResponses.length
                ? "highlight-container"
                : "highlight-bw"
            }
          >
            <div className="screen-title-container">
              <div className="screen-title-content">
                <div className="d-flex flex-direction-c">
                  <Link className="back-button-container left-0" to="/">
                    <img src={backIcon} alt="back" />
                  </Link>
                  <div>
                    High<span>lights</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={"highlight-input-main-container"}>
              <div className="Search-input-field-container-for-table3 highlight-input-container">
                <SearchIcon className="search-icon-for-table" />
                <input
                  className="search-input-for-table2"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => {
                    if (e.target.value == "" && searchedRecord) {
                      this.getHighlightedVideo();
                      this.setState({ searchedRecord: false });
                    }
                    this.setState({ searchQuery: e.target.value });
                  }}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                      this.postSearchHighlight(searchQuery);
                    }
                  }}
                />
                {searchQuery && (
                  <div className="search-bar-right-container">
                    <CloseIcon
                      className="mg-right-10 cp"
                      onClick={() => {
                        if (searchedRecord) {
                          this.getHighlightedVideo();
                          this.setState({ searchedRecord: false });
                        }
                        this.setState({ searchQuery: "" });
                      }}
                    />
                    <p
                      className="cancel-Search-icon"
                      onClick={() => this.postSearchHighlight(searchQuery)}
                    >
                      Search
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="highlight-tile-container">
              {shareMediaDetailsResponses.map((item, index) => (
                <div className="highlight-tile" key={index}>
                  <ReactPlayer
                    className="videoPlayer1 video-player"
                    url={item?.eventMedia?.videoPath}
                    controls
                    onPlay={() => this.increaseViewCount(item?.shareMediaId)}
                  />
                  <div className="hightlight-tile-footer">
                    <div className="school-name-container">
                      <img
                        alt=""
                        src={
                          item?.school?.uploadedLogo?.filePath || blankProfile
                        }
                        // src={item?.school?.uploadedLogo?.filePath}
                        className="school-logo"
                        onerror="this.src='defaultImageURL'"
                      />
                      <div>{item?.school?.schoolName || ""}</div>
                    </div>
                    <div
                      className="highlight-share"
                      onClick={() =>
                        this.setDialogData(item?.eventMedia?.videoPath, true)
                      }
                    >
                      <img alt="" src={shareIcon} />
                    </div>
                  </div>
                  <div className="highlight-detail">
                    {item?.viewsCount} Views{" "}
                    <span className="highlight-circle" />{" "}
                    {moment(new Date(item?.createdDateAt + "Z")).format(
                      "MM/DD/YYYY HH:mm"
                    )}
                  </div>
                </div>
              ))}
              {flag == true && (
                <p className="text-center w-100 nodatabox mg-top-70">
                  No Highlights Videos available currently
                </p>
              )}
              {loading == true && (
                <p className="text-center w-100 nodatabox mg-top-70">
                  Loading...
                </p>
              )}
            </div>
          </div>
        </section>
        <ShareModal
          visible={visible}
          shareUrl={socialShare}
          inputUrl={inputUrl}
          close={() => this.setDialogData("", false)}
          handleChange={this.handleChange}
        />
      </>
    );
  }
}

export default ContactUs;
